﻿export const initialise = () => {
    const overlay = document.querySelector<HTMLDialogElement>('#dialog-search-overlay')
    if (!overlay) return

    const dialogWidgetSearch = document.querySelector<HTMLDivElement>('#dialog-search-overlay .dialog-search-overlay__widget-search')
    const buttonClose = document.querySelector<HTMLButtonElement>('#dialog-search-overlay .dialog-search-overlay__button-close')
    const buttonOpen = document.querySelector<HTMLButtonElement>('.main-site-header__search')
    if (!dialogWidgetSearch || !buttonClose || !buttonOpen) return

    bindEvents(overlay, buttonClose, buttonOpen)
    autocompleteSuggestions(dialogWidgetSearch)
}

export const openOverlay = (overlay: HTMLDialogElement) => {
    if (overlay.open) return
    overlay.showModal()
    document.body.classList.add('overlay-open')
}
export const closeOverlay = (overlay: HTMLDialogElement) => {
    if (!overlay.open) return
    overlay.close()
    document.body.classList.remove('overlay-open')
}

const bindEvents = (overlay: HTMLDialogElement, buttonClose: HTMLButtonElement, buttonOpen: HTMLButtonElement) => {
    buttonOpen.addEventListener('click', () => {
        openOverlay(overlay)
    })

    buttonClose.addEventListener('click', () => {
        closeOverlay(overlay)
    })

    overlay.addEventListener('close', () => {
        document.body.classList.remove('overlay-open')
    })
}

const autocompleteSuggestions = (dialogWidgetSearch: HTMLDivElement) => {
    const autocompleteSuggestion = document.querySelector<HTMLElement>('.dialog-search-overlay__widget-search.autocomplete-suggestions')
    if (!autocompleteSuggestion) return

    autocompleteSuggestion.setAttribute('popover', '')
    dialogWidgetSearch?.appendChild(autocompleteSuggestion)
}